
























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Api from '@/project/http/Api.service';
import {
    ReferencedProductsViewModel, FacetValueViewObject
} from '@/types/apiServerContract';
import { HttpCancelError } from '@/core/http/HttpCancelError';
import ProductAccessoriesCategoryOverlayService
    from '@/project/modals/overlays/ProductAccessoriesCategoryOverlay.service';
export enum ProductRelationType {
    'accessories' = 'accessories',
    'exactAlternatives' = 'exactAlternatives',
    'similarAlternatives' = 'similarAlternatives',
}
const accessoriesPageSize = 5;
@Component
export default class ProductAccessoriesSearchControl extends Vue {
    @Prop({ type: String, required: true })
    productId!: string;

    @Prop({ type: Boolean, default: true })
    allowSearch!: boolean;

    @Prop({ type: String, default: ProductRelationType.accessories })
    relationType!: string;

    searchResult: ReferencedProductsViewModel | null = null;
    searching = false;
    fromNumber: number = 0;
    toNumber: number = accessoriesPageSize;

    getCategoryIds(): string[] {
        return (this.searchResult?.categoryFacet.values.filter(v => v.selected) ?? [])?.map(v => v.key);
    }

    get getProductsResult() {
        return this.searchResult?.products || [];
    }

    setSearching(isSearching: boolean) {
        this.searching = isSearching;
        if (!isSearching) {
            this.$emit('loaded', this.relationType);
        }
    }

    async search() {
        if (!this.allowSearch || this.searching) return;

        this.setSearching(true);
        try {
            const result = this.relationType === ProductRelationType.similarAlternatives
                ? await Api.product.similarAlternatives(this.productId, this.getCategoryIds(), this.fromNumber, this.toNumber)
                : this.relationType === ProductRelationType.exactAlternatives ? await Api.product.exactAlternatives(this.productId, this.getCategoryIds(), this.fromNumber, this.toNumber)
                    : await Api.product.accessories(this.productId, this.getCategoryIds(), this.fromNumber, this.toNumber);
            this.searchResult = Object.freeze(result);

            this.setSearching(false);
        } catch (error) {
            if (error instanceof HttpCancelError) {
                // Ok - cancelled by newer request
            } else {
                this.setSearching(false);
                throw error;
            }
        }
    }

    async clickShowCategoryFilter() {
        const facetValues = await ProductAccessoriesCategoryOverlayService.show(this.searchResult?.categoryFacet.values || []) as FacetValueViewObject[];
        if (this.searchResult && facetValues) {
            this.resetPaging(); // always reset paging, facetValues will be undefined if modal is canceled
            this.searchResult.categoryFacet.values = facetValues;
            this.search();
        }
    }

    handleNextPage() {
        this.toNumber = this.toNumber + accessoriesPageSize;
        this.search();
    }

    resetPaging() {
        this.fromNumber = 0;
        this.toNumber = accessoriesPageSize;
    }

    @Watch('allowSearch')
    onAllowSearchChange() {
        if (this.allowSearch) {
            this.search();
        }
    }

    @Watch('productId', {
        immediate: true
    })
    onProductIdChange() {
        this.search();
    }

    mounted() {
        this.resetPaging();
        this.search();
    }
}
